module.exports = __webpack_public_path__ + "static/img/icon-checked-grenn.9e83574e.png";